import { render, staticRenderFns } from "./borrador-router.vue?vue&type=template&id=ea29c270"
import script from "./borrador-router.vue?vue&type=script&setup=true&lang=js"
export * from "./borrador-router.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports